import Vue from "vue";
import VueRouter from "vue-router";

import Login from '../components/login/Login';
import ResetPassword from '../components/login/ResetPassword';
import ChangePassword from '../components/login/ChangePassword';
import Home from '../components/home/Home';
import Profile from '../components/member/Profile';
import EditProfile from '../components/member/EditProfile';
import About from '../components/about/About';
import CreateVacation from '../components/vacations/CreateVacation';
import VacationDetail from '../components/vacations/VacationDetail';
import VacationList from '../components/vacations/sp/VacationList';

import dataStore from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    routes: [
        { name: "home", path: "/", component: Home, alias: "/index" },
        { name: "login", path: "/login", component: Login,
            beforeEnter: (to, from, next) => {
                dataStore.dispatch("signOut");
                next();
            }
        },
        { name: "resetpassword", path: "/reset", component: ResetPassword},
        { name: "changepassword", path: "/changepassword", component: ChangePassword},
        { name: "profile", path: "/profile/:userid", component: Profile},
        { name: "editprofile", path: "/editprofile/:userid", component: EditProfile},
        { name: "about", path: "/about", component: About},
        { name: "applyVacation", path: "/:option(create|edit)/:vationid(\\d+)?", component: CreateVacation},
        { name: "detailVaction", path: "/detail/:vacationid", component: VacationDetail},
        { name: "listVacation", path: "/list", component: VacationList},
        { path: "*", redirect: "/" }
    ]
});

export default router;

router.beforeEach((to, from, next) => {
    if (to.name != "login" && to.name != "resetpassword" && !dataStore.getters.isSignedIn) {
        next({name: "login"});
    } else {
        next();
    }
});